import axios from 'axios';
import { BASE_URL } from 'utils/constants/Api';

import {
  IRelatedOrdersDto,
  PaginationQuery,
} from '@project44-models/shipment-list';

export async function fetchRelatedOrders(payload: {
  shipmentId: string;
  paging?: PaginationQuery;
}) {
  const data = await axios.post<IRelatedOrdersDto>(
    `${BASE_URL}/shipments/related-orders`,
    payload,
    {
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json',
      },
    },
  );

  return data?.data;
}
